import React, { useCallback } from 'react'
import * as Yup from 'yup'
import { useStyles } from './styles'
import SimpleInput from 'components/common/SimpleInput/SimpleInput'
import { THEME_DARK } from 'constants.js'
import { createPass } from 'redux/slices/passes/thunks'
import { getCreatePassState } from 'redux/slices/passes'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import { useDispatch, useSelector } from 'react-redux'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons'

interface JoinEventFormProps {
    cover: string
    showId: string
    title: string
    posterImg: string
}

type Inputs = {
    fullName: string
    email: string
}

const eventJoinValidationSchema = Yup.object({
    fullName: Yup.string()
        .required('Please, enter your full name')
        .min(3)
        .max(25),
    email: Yup.string()
        .required('Please, enter your email address')
        .email(),
})

const JoinEventForm: React.FC<JoinEventFormProps> = React.memo(({ cover, showId, posterImg }) => {
    const classes = useStyles({ cover })
    const dispatch = useDispatch()
    const createPassState = useSelector(getCreatePassState)
    const onSubmit = useCallback(
        (data: Inputs) => {
            dispatch(createPass({ showId, fullName: data.fullName, email: data.email }))
        },
        [dispatch, showId],
    )

    const { register, handleSubmit, errors } = useForm<Inputs>({
        resolver: yupResolver(eventJoinValidationSchema),
        mode: 'onSubmit',
    })

    return (
        <div className={classes.container}>
            <div className={classes.formContainer}>
                <div className={classes.title}>
                    <img src={posterImg} className={classes.posterImg} alt="posterImg" />
                    <h2>Join the Event</h2>
                    <h3>Please enter your name and email address</h3>
                </div>

                <form onSubmit={handleSubmit(onSubmit)} noValidate>
                    <SimpleInput
                        className={classes.input}
                        error={errors?.fullName?.message}
                        themeColor={THEME_DARK}
                        type="text"
                        enableErrorIcon
                        placeholder="Name"
                        variant="secondary"
                        name="fullName"
                        ref={register}
                    />

                    <SimpleInput
                        className={classes.input}
                        error={errors?.email?.message}
                        themeColor={THEME_DARK}
                        type="text"
                        enableErrorIcon
                        placeholder="Email"
                        variant="secondary"
                        name="email"
                        ref={register}
                    />

                    <input
                        type="submit"
                        value={!createPassState.loading ? 'Join Event' : 'Joining Event'}
                        className={classes.submitBtn}
                    />

                    {!createPassState.loading && createPassState.error && (
                        <div className={classes.error}>
                            <FontAwesomeIcon className={classes.errorIcon} icon={faExclamationTriangle} />
                            {createPassState.error}
                        </div>
                    )}
                </form>
            </div>
        </div>
    )
})

export default React.memo(JoinEventForm)
